import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  setItemWrapper: {
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  setItemWrapperWithSplitBySideExercise: {
    // height: '64px',
  },
  oddLine: {
    background: theme.palette.exerciseStatus.notStartedOddLine,
  },
  itemDragging: {
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primaryTransparent,

    '& > div': {
      display: 'none',
    },
  },
  itemDragTarget: {
    border: `1px dashed ${theme.palette.primary.main}`,
    // backgroundColor: theme.palette.error.light,
  },

  typeContainer: {
    height: '100%',
    cursor: 'pointer',
  },
  menuContainer: {
    width: '150px',
    maxWidth: '150px',
    minWidth: '150px',
  },
  typeItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  optionFieldContainer: {
    '& .MuiOutlinedInput-root.MuiInputBase-root': {
      paddingLeft: '0 !important',
    },
  },
}));
